export const Colors = {
    NEUTRAL_WHITE: '#FFFFFF',
    NEUTRAL_BLACK: '#000000',
    NEUTRAL_GRAY: '#e0e0e0',
    BLUE: '#0A0D30',
    BLUE_OPACITY: '#0a0d3054',
    YELLOW: '#FAA938',
    GREEN: '#046b3bff',
    RED_800: '#CC0400',
};

export const FontColors = {
    PRIMARY: '#0A0D30',
    SECONDARY: '#7F7F7F',
};

export const FontFamilies = {
    PRIMARY: '"Roboto", "Helvetica", "Arial", sans-serif',
};

export const FontLetterSpacings = {
    SMALL: '0.5px',
    MEDIUM: '0.15px',
    LARGE: '1.25px',
};

export const FontLineHeights = {
    SMALL: '120%',
    MEDIUM: '150%',
};

export const FontSizes = {
    ONE: '8px',
    ONE_HALF: '12px',
    ONE_QUARTER: '14px',
    TWO: '16px',
    THREE: '24px',
    FOUR: '32px',
};

export const FontWeights = {
    THIN: 300,
    REGULAR: 400,
    BOLD: 500,
    BOLDER: 600,
};

export const Spaces = {
    NONE: '0',
    HALF: '4px',
    ONE: '8px',
    ONE_HALF: '12px',
    TWO: '16px',
    THREE: '24px',
    FOUR: '32px',
    FIVE: '40px',
    SIX: '48px',
    SEVEN: '56px',
    EIGHT: '64px',
    NINE: '72px',
    TEN: '80px',
};

export const BorderRadiuses = {
    ONE: '8px',
};

export const Shadows = {
    ONE: '0px 0px 2px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.24)',
    TWO: '0px 1px 5px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.14)',
};